import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'

import { ROUTE_PATH } from 'lib/paths'

import { useGetSubscriptionQuery } from 'store/api/yay/payment'

import ImageLoader from 'components/ImageLoader'

import './style.scss'

const SystemAnnouncement = ({}) => {
  const { t } = useTranslation()
  const {
    data: subscriptionData,
    isLoading,
    isSuccess,
  } = useGetSubscriptionQuery()

  const hasWebSubscriptionData = subscriptionData?.status === 'ACTIVE'

  if (isSuccess && hasWebSubscriptionData) return null

  return (
    <div className="SystemAnnouncement">
      {!isLoading && !hasWebSubscriptionData && (
        <>
          <Link
            className="SystemAnnouncement__handle"
            to={ROUTE_PATH.SETTING_SUBSCRIPTION}
          />
          <div className="SystemAnnouncement__a__icon">
            <ImageLoader url="/images/icon-megaphone.svg" />
          </div>
          <div className="SystemAnnouncement__text">
            <h4>{t('system_update.vip_system_update')}</h4>
            <p>{t('system_update.vip_system_update_description')}</p>
          </div>
        </>
      )}
    </div>
  )
}

export default SystemAnnouncement
